import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

import Logo from '../../layout/Logo';
import openSignInDialog from '../dialog/open';

function RequireSignInOverlay() {
  return (
    <Modal backdrop="static" isOpen>
      <ModalHeader className="bg-black text-white">
        <Logo />
      </ModalHeader>
      <ModalBody className="text-center">
        <h3>Your session expired</h3>
        <p>Please sign in to continue.</p>
        <Button
          size="lg"
          color="primary"
          className="mt-3"
          onClick={openSignInDialog}
        >
          Sign in
        </Button>
        <hr />
        <p>
          If you don&apos;t have an account yet, click{' '}
          <a href="https://sites.google.com/zalando.de/salescockpit/login?authuser=0">
            here
          </a>
          .
        </p>
      </ModalBody>
    </Modal>
  );
}

RequireSignInOverlay.propTypes = {};

export default RequireSignInOverlay;
